import { denormalize } from "normalizr";
import { get, memoize } from "lodash";

import { fundingRequest } from "../../../api/schema";

export default id =>
  memoize(state => {
    try {
      const denormalized = denormalize(
        { fundingRequest: id },
        { fundingRequest },
        state.entities
      );
      return get(denormalized.fundingRequest, "debtor.id");
    } catch (err) {
      return "";
    }
  });
